<template>
  <div class="discord">
    <p @click="jumpDiscord()">Discord</p>
    <!-- <a href="https://discord.gg/EnsvSAVZCv">Discord</a> -->
  </div>
</template>

<script>
export default {
  name: "",
  methods: {
    jumpDiscord() {
      window.open("https://discord.gg/EnsvSAVZCv", "_blank");
    }
  }
};
</script>
<style scoped lang="scss">
.discord {
  cursor: pointer;
  z-index: 9;
  background-color: #000;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 68px;
  height: 68px;
  background: url("~@/assets/img/top/titleicon3.png") no-repeat;
  p {
    font-family: icomoon;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    line-height: 108px;
  }
}

@media (max-width: 1199px) {
  .discord {
    cursor: pointer;
    z-index: 100;
    position: fixed;
    bottom: 0.266667rem;
    right: 0.266667rem;
    width: 0.826667rem;
    height: 0.826667rem;
    background: url("~@/assets/img/top/titleicon3.png") no-repeat;
    background-size: 0.826667rem 0.826667rem;
    p {
      font-family: icomoon;
      font-size: 0.16rem;
      font-weight: 700;
      color: #fff;
      text-align: center;
      line-height: 1.333333rem;
    }
  }
}
@media (max-width: 991px) {
  .discord {
    cursor: pointer;
    z-index: 100;
    position: fixed;
    bottom: 0.266667rem;
    right: 0.266667rem;
    width: 0.826667rem;
    height: 0.826667rem;
    background: url("~@/assets/img/top/titleicon3.png") no-repeat;
    background-size: 0.826667rem 0.826667rem;
    p {
      font-family: icomoon;
      font-size: 0.16rem;
      font-weight: 700;
      color: #fff;
      text-align: center;
      line-height: 1.333333rem;
    }
  }
}
@media (max-width: 767px) {
  .discord {
    cursor: pointer;
    z-index: 100;
    position: fixed;
    bottom: 0.266667rem;
    right: 0.266667rem;
    width: 0.826667rem;
    height: 0.826667rem;
    background: url("~@/assets/img/top/titleicon3.png") no-repeat;
    background-size: 0.826667rem 0.826667rem;
    p {
      p {
        font-family: icomoon;
        font-size: 0.133333rem;
        font-weight: 700;
        color: #fff;
        text-align: center;
        line-height: 1.333333rem;
      }
    }
  }
}
</style>
